import { render, staticRenderFns } from "./indexGx.vue?vue&type=template&id=ab361500&scoped=true"
import script from "./indexGx.vue?vue&type=script&lang=js"
export * from "./indexGx.vue?vue&type=script&lang=js"
import style0 from "./indexGx.vue?vue&type=style&index=0&id=ab361500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab361500",
  null
  
)

export default component.exports